/* eslint-disable no-template-curly-in-string */

// Form
import * as yup from "yup"

export const productValidationSchema = yup.object().shape({
  Customer_code: yup.string().label("Customer Code").optional().required(),
  Customer_name: yup.string().label("Customer Name").required()
})